export default __webpack_public_path__ + "static/media/portfolio-cregar-3.86c21b3f.jpg";